import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { formatPrice } from 'utils';
import { ui } from 'components';
import apiHOCs from 'components/apiHOCs';
import CartRow from './CartRow';

import './style.scss';

const CartTable = ({
  cart,
  deleteProduct,
  addProduct,
  removeCart,
  goToCheckout,
  productsListApiHOC: {
    products,
  },
}) => (
  products.length ?
    <div className="cart-table">
      <div className="cart-table__row">
        <div className="cart-table__row__img" />
        <div className="cart-table__row__name">
          <span className="cart-table__header-caption">Наименование</span>
        </div>
        <div className="cart-table__row__count">
          <span className="cart-table__header-caption">Количество</span>
        </div>
        <div className="cart-table__row__price">
          <span className="cart-table__header-caption">Стоимость</span>
        </div>
        <div className="cart-table__row__sum">
          <span className="cart-table__header-caption">Сумма</span>
        </div>
        <div className="cart-table__row__delete" />
      </div>
      <hr className="cart-table__hr" />
      {
        Object.entries(cart).map((prop) => {
          if (prop[0] !== 'quantity' && prop[0] !== 'sum' && prop[1] !== undefined) {
            const fullProduct = products.find(product => product.id === prop[1].id);
            console.log(products, prop, fullProduct);
            return <CartRow
              key={prop[0]}
              fullProduct={fullProduct}
              properties={{
                count: prop[1].count,
                size: prop[1].size,
                color: prop[1].color,
              }}
              addProduct={addProduct}
              deleteProduct={deleteProduct}
            />;
          }
          return null;
        })
      }
      <div className="cart-table__row">
        <div className="cart-table__row__img" />
        <div className="cart-table__row__total">
          <p>Всего наименований
            <span> {cart.quantity} </span>
            на сумму
            <span> {formatPrice(cart.sum)} руб.</span>
          </p>
        </div>
        <div className="cart-table__row__clean-button">
          <ui.Buttons.BaseButton
            title="очистить корзину"
            style={{
              backgroundColor: '#777',
            }}
            onClick={removeCart}
          />
        </div>
        <div className="cart-table__row__buy-button">
          <ui.Buttons.BaseButton
            title="сформировать заказ"
            onClick={goToCheckout}
          />
        </div>
      </div>
    </div> : <ui.LoadingSpinner fullSize />
);

CartTable.propTypes = {
  deleteProduct: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  goToCheckout: PropTypes.func.isRequired,
  removeCart: PropTypes.func.isRequired,

  cart: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    sum: PropTypes.number.isRequired,
  }).isRequired,

  productsListApiHOC: PropTypes.shape({
    products: PropTypes.array,
  }).isRequired,
};

export default compose(
  apiHOCs.ProductsListApiHOC(),
)(CartTable);



// WEBPACK FOOTER //
// ./src/components/ui/CartTable/index.js